<template>
    <v-container
            id="client-card"
            fluid
            tag="section"
            pt-0
            :key="clientId"
    >
        <v-row class="mt-1">
            <v-col cols="12" md="5">
                <base-material-card>
                    <template v-slot:heading v-if="canEditCard">
                        <div class="subtitle-1 font-weight-light d-flex">
                            <v-spacer/>
                            <template v-if="!editMode">
                                <v-btn
                                        color="red darken-1"
                                        x-small
                                        depressed
                                        @click="deleteItem"
                                        class="mr-3"
                                        v-if="canEditCard"
                                >
                                    {{$vuetify.lang.t('$vuetify.page.action.btnDelete')}}
                                </v-btn>
                                <v-btn
                                        color="blue darken-1"
                                        x-small
                                        depressed
                                        @click="edit"
                                        v-if="canEditCard"
                                >
                                    {{$vuetify.lang.t('$vuetify.page.action.btnEdit')}}
                                </v-btn>
                                <v-dialog v-model="dialogDelete" max-width="500px">
                                    <v-card>
                                        <v-card-title class="headline">{{$vuetify.lang.t('$vuetify.page.all.deleteMsg')}}
                                        </v-card-title>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="closeDelete">
                                                {{$vuetify.lang.t('$vuetify.page.action.btnCancel')}}
                                            </v-btn>
                                            <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                                                   :loading="axiosLoading">
                                                {{$vuetify.lang.t('$vuetify.page.action.btnYes')}}
                                            </v-btn>
                                            <v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </template>
                        </div>
                    </template>
                    <v-form
                            class="mt-2"
                            ref="form"
                            v-model="valid"
                            lazy-validation
                            v-if="editMode"
                    >
                        <v-container>
                            <v-row>
                                <!--                                    <v-col-->
                                <!--                                            cols="4"-->
                                <!--                                    >-->
                                <!--                                        <v-text-field-->
                                <!--                                                :label="$vuetify.lang.t('$vuetify.page.ClientsCard.number')"-->
                                <!--                                                v-model="currentClient.number"-->
                                <!--                                                disabled-->
                                <!--                                        ></v-text-field>-->
                                <!--                                    </v-col>-->
                                <v-col
                                        cols="6"
                                >
                                    <v-combobox
                                            dense
                                            outlined
                                            hide-details="auto"
                                            v-model="currentClient.company"
                                            :filter="filter"
                                            :label="$vuetify.lang.t('$vuetify.page.ClientsCard.companyName')"
                                            :items="companyDictList"
                                            :search-input.sync="search"
                                            item-text="name"
                                            @keydown.enter="createNewCompany(search)"
                                            :key="clientComboboxKey"
                                    >
                                        <template v-slot:no-data>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        Нет результатов по запросу "<strong>{{ search }}</strong>". Нажмите <kbd>enter</kbd> для создания
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-combobox>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col
                                        cols="12">
                                    <v-text-field
                                            dense
                                            outlined
                                            hide-details="auto"
                                            :label="$vuetify.lang.t('$vuetify.page.ClientsCard.clientName')"
                                            v-model="currentClient.name"
                                            :rules="[fieldValidationRules.required(vue)]"
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                    cols="12"
                                >
                                    <v-combobox
                                        dense
                                        outlined
                                        hide-details="auto"
                                        v-model="currentClient.parentClient"
                                        :filter="filter"
                                        :label="$vuetify.lang.t('$vuetify.page.ClientsCard.parentClientName')"
                                        :items="clientDictList"
                                        item-text="name"
                                        :key="clientComboboxKey1"
                                    >
                                    </v-combobox>
                                </v-col>
                                <v-col
                                        cols="12">
                                    <v-text-field
                                            dense
                                            outlined
                                            hide-details="auto"
                                            :label="$vuetify.lang.t('$vuetify.page.ClientsCard.address')"
                                            v-model="currentClient.address"
                                            :rules="[fieldValidationRules.required(vue)]"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col
                                        cols="12"
                                        md="4"
                                >
                                    <v-menu
                                            v-model="hostingDateMenu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                    dense
                                                    outlined
                                                    hide-details="auto"
                                                    v-model="currentClient.hostingDate"
                                                    :label="$vuetify.lang.t('$vuetify.page.ClientsCard.hostingDate')"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    clearable
                                                    @click:clear="currentClient.hostingDate = null"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                                locale="ru-ru"
                                                first-day-of-week="1"
                                                no-title
                                                v-model="currentClient.hostingDate"
                                                @input="hostingDateMenu = false"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col
                                        cols="12"
                                        md="4"
                                >
                                    <v-menu
                                            v-model="launchDateMenu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                    dense
                                                    outlined
                                                    hide-details="auto"
                                                    v-model="currentClient.launchDate"
                                                    :label="$vuetify.lang.t('$vuetify.page.ClientsCard.launchDate')"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    clearable
                                                    @click:clear="currentClient.launchDate = null"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                                locale="ru-ru"
                                                first-day-of-week="1"
                                                no-title
                                                v-model="currentClient.launchDate"
                                                @input="launchDateMenu = false"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col
                                        cols="12"
                                        md="4"
                                >
                                    <v-menu
                                            v-model="closeDateMenu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                    dense
                                                    outlined
                                                    hide-details="auto"
                                                    v-model="currentClient.closeDate"
                                                    :label="$vuetify.lang.t('$vuetify.page.ClientsCard.closeDate')"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    clearable
                                                    @click:clear="currentClient.closeDate = null"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                                locale="ru-ru"
                                                first-day-of-week="1"
                                                no-title
                                                v-model="currentClient.closeDate"
                                                @input="closeDateMenu = false"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col
                                        cols="6">
                                    <v-autocomplete
                                            dense
                                            outlined
                                            hide-details="auto"
                                            :label="$vuetify.lang.t('$vuetify.page.ClientsCard.licenseType')"
                                            :items="licenseTypeDictList"
                                            item-text="name"
                                            item-value="id"
                                            v-model="currentClient.licenseType.id"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col
                                        cols="6">
                                    <v-autocomplete
                                            dense
                                            outlined
                                            hide-details="auto"
                                            :label="$vuetify.lang.t('$vuetify.page.ClientsCard.softwareVersionType')"
                                            :items="softwareVersionTypeDictList"
                                            item-text="name"
                                            item-value="id"
                                            v-model="currentClient.softwareVersionType.id"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col
                                        cols="12">
                                    <v-text-field
                                            dense
                                            outlined
                                            hide-details="auto"
                                            :label="$vuetify.lang.t('$vuetify.page.ClientsCard.licenseDescription')"
                                            v-model="currentClient.licenseDescription"
                                            counter="128"
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                        cols="6">
                                    <v-text-field
                                            dense
                                            outlined
                                            hide-details="auto"
                                            :label="$vuetify.lang.t('$vuetify.page.ClientsCard.serverAddress')"
                                            v-model="currentClient.serverAddress"
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                        cols="6">
                                    <v-text-field
                                            dense
                                            outlined
                                            hide-details="auto"
                                            :label="$vuetify.lang.t('$vuetify.page.ClientsCard.serverPassword')"
                                            v-model="currentClient.serverPassword"
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                        cols="12">
                                    <v-text-field
                                            dense
                                            outlined
                                            hide-details="auto"
                                            :label="$vuetify.lang.t('$vuetify.page.ClientsCard.networkDescription')"
                                            v-model="currentClient.networkDescription"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                    <div class="mt-2" v-else-if="currentClient">
                        <v-row>
                            <!--                                    <v-col-->
                            <!--                                            cols="4"-->
                            <!--                                    >-->
                            <!--                                        <v-text-field-->
                            <!--                                                :label="$vuetify.lang.t('$vuetify.page.ClientsCard.number')"-->
                            <!--                                                v-model="currentClient.number"-->
                            <!--                                                disabled-->
                            <!--                                        ></v-text-field>-->
                            <!--                                    </v-col>-->
                            <v-col
                                    cols="8"
                            >
                                <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.page.ClientsCard.companyName')"
                                        v-model="companyName"
                                        readonly
                                        outlined
                                        dense
                                        hide-details="auto"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                    cols="12">
                                <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.page.ClientsCard.clientName')"
                                        v-model="currentClient.name"
                                        :rules="[fieldValidationRules.required(vue)]"
                                        readonly
                                        outlined
                                        dense
                                        hide-details="auto"
                                ></v-text-field>
                            </v-col>
                            <v-col
                                    cols="12">
                                <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.page.ClientsCard.parentClientName')"
                                        v-model="parentClientName"
                                        :rules="[fieldValidationRules.required(vue)]"
                                        readonly
                                        outlined
                                        dense
                                        hide-details="auto"
                                ></v-text-field>
                            </v-col>
                            <v-col
                                    cols="12">
                                <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.page.ClientsCard.address')"
                                        v-model="currentClient.address"
                                        :rules="[fieldValidationRules.required(vue)]"
                                        readonly
                                        outlined
                                        dense
                                        hide-details="auto"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>

                            <v-col
                                    cols="4"
                            >
                                <v-text-field
                                        v-model="currentClient.hostingDate"
                                        :label="$vuetify.lang.t('$vuetify.page.ClientsCard.hostingDate')"
                                        readonly
                                        outlined
                                        dense
                                        hide-details="auto"
                                ></v-text-field>
                            </v-col>
                            <v-col
                                    cols="4"
                            >
                                <v-text-field
                                        v-model="currentClient.launchDate"
                                        :label="$vuetify.lang.t('$vuetify.page.ClientsCard.launchDate')"
                                        readonly
                                        outlined
                                        dense
                                        hide-details="auto"
                                ></v-text-field>
                            </v-col>
                            <v-col
                                    cols="4"
                            >
                                <v-text-field
                                        v-model="currentClient.closeDate"
                                        :label="$vuetify.lang.t('$vuetify.page.ClientsCard.closeDate')"
                                        readonly
                                        outlined
                                        dense
                                        hide-details="auto"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                    cols="6">
                                <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.page.ClientsCard.licenseType')"
                                        v-model="licenseTypeName"
                                        readonly
                                        outlined
                                        dense
                                        hide-details="auto"
                                ></v-text-field>
                            </v-col>
                            <v-col
                                    cols="6">

                                <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.page.ClientsCard.softwareVersionType')"
                                        v-model="softwareVersionTypeName"
                                        readonly
                                        outlined
                                        dense
                                        hide-details="auto"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                    cols="12">
                                <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.page.ClientsCard.licenseDescription')"
                                        v-model="currentClient.licenseDescription"
                                        readonly
                                        outlined
                                        dense
                                        hide-details="auto"
                                ></v-text-field>
                            </v-col>
                            <v-col
                                    cols="6">
                                <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.page.ClientsCard.serverAddress')"
                                        v-model="currentClient.serverAddress"
                                        readonly
                                        outlined
                                        dense
                                        hide-details="auto"
                                ></v-text-field>
                            </v-col>
                            <v-col
                                    cols="6">
                                <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.page.ClientsCard.serverPassword')"
                                        v-model="currentClient.serverPassword"
                                        readonly
                                        outlined
                                        dense
                                        hide-details="auto"
                                ></v-text-field>
                            </v-col>
                            <v-col
                                    cols="12">
                                <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.page.ClientsCard.networkDescription')"
                                        v-model="currentClient.networkDescription"
                                        readonly
                                        outlined
                                        dense
                                        hide-details="auto"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </div>
                    <template v-slot:actions v-if="editMode">
                        <v-btn
                                color="red darken-1"
                                text
                                @click="cancel"
                        >
                            {{$vuetify.lang.t('$vuetify.page.action.btnCancel')}}
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                                color="blue darken-1"
                                text
                                @click="save"
                                :loading="axiosLoading" :disabled="!valid"
                        >
                            {{$vuetify.lang.t('$vuetify.page.action.btnSave')}}
                        </v-btn>
                    </template>
                </base-material-card>
            </v-col>
            <v-col cols="12" md="7" v-if="currentClient">
                <v-expansion-panels accordion>
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            {{$vuetify.lang.t('$vuetify.page.ClientsCard.childClients.name')}}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <client-child></client-child>
                        </v-expansion-panel-content>
                    </v-expansion-panel>


                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            {{$vuetify.lang.t('$vuetify.page.ClientsCard.webCash.name')}}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <client-web-cash v-if="!isNew"></client-web-cash>
                            <h5 v-else>{{$vuetify.lang.t('$vuetify.page.all.txtNeedCreateClient')}}</h5>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            {{$vuetify.lang.t('$vuetify.page.ClientsCard.suspendHistory.name')}}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <client-suspend-history v-if="!isNew"></client-suspend-history>
                            <h5 v-else>{{$vuetify.lang.t('$vuetify.page.all.txtNeedCreateClient')}}</h5>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            {{$vuetify.lang.t('$vuetify.page.ClientsCard.serviceHistory.name')}}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <client-service-history v-if="!isNew"></client-service-history>
                            <h5 v-else>{{$vuetify.lang.t('$vuetify.page.all.txtNeedCreateClient')}}</h5>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            {{$vuetify.lang.t('$vuetify.page.ClientsCard.stations.name')}}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <client-station v-if="!isNew"></client-station>
                            <h5 v-else>{{$vuetify.lang.t('$vuetify.page.all.txtNeedCreateClient')}}</h5>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel @click="getPrintersData">
                        <v-expansion-panel-header>
                            {{$vuetify.lang.t('$vuetify.page.ClientsCard.printers.name')}}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <client-printers v-if="!isNew"></client-printers>
                            <h5 v-else>{{$vuetify.lang.t('$vuetify.page.all.txtNeedCreateClient')}}</h5>
                        </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel @click="getPrintersData">
                        <v-expansion-panel-header>
                            {{$vuetify.lang.t('$vuetify.page.ClientsCard.remote.name')}}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <client-remote v-if="!isNew"></client-remote>
                            <h5 v-else>{{$vuetify.lang.t('$vuetify.page.all.txtNeedCreateClient')}}</h5>
                        </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            {{$vuetify.lang.t('$vuetify.page.ClientsCard.contact.name')}}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <client-contact v-if="!isNew"></client-contact>
                            <h5 v-else>{{$vuetify.lang.t('$vuetify.page.all.txtNeedCreateClient')}}</h5>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            {{$vuetify.lang.t('$vuetify.page.ClientsCard.document.name')}}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <client-document v-if="!isNew"></client-document>
                            <h5 v-else>{{$vuetify.lang.t('$vuetify.page.all.txtNeedCreateClient')}}</h5>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel
                        readonly
                        @click="showClientServiceList"
                    >
                        <v-expansion-panel-header>
                            {{$vuetify.lang.t('$vuetify.page.ClientsCard.services.name')}}

                            <template v-slot:actions>
                                <v-icon>
                                    mdi-information-outline
                                </v-icon>
                            </template>
                        </v-expansion-panel-header>
                    </v-expansion-panel>
                </v-expansion-panels>
                <v-dialog
                    v-model="clientServiceListDialog"
                    fullscreen
                    hide-overlay
                    transition="dialog-bottom-transition"
                >
                    <v-card>
                        <v-toolbar
                                dark
                                color="primary"
                        >
                            <v-btn
                                    icon
                                    dark
                                    @click="clientServiceListDialog = false"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <client-services></client-services>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ClientServiceHistory from "@/view/dashboard/pages/client/ClientServiceHistory";
    import ClientSuspendHistory from "@/view/dashboard/pages/client/ClientSuspendHistory";
    import ClientWebCash from "@/view/dashboard/pages/client/ClientWebCash";
    import ClientStation from "@/view/dashboard/pages/client/ClientStations";
    import ClientPrinters from "@/view/dashboard/pages/client/ClientPrinters";
    import ClientContact from "@/view/dashboard/pages/client/ClientContact";
    import ClientDocument from "@/view/dashboard/pages/client/ClientDocuments";
    import ClientRemote from "@/view/dashboard/pages/client/ClientRemote";
    import ClientServices from "@/view/dashboard/pages/client/ClientServices";
    import ClientChild from "@/view/dashboard/pages/client/ClientChild";

    export default {
        name: "ClientCard",
        components: {
            ClientServices,
            ClientRemote,
            ClientDocument,
            ClientContact,
            ClientPrinters, ClientStation, ClientWebCash, ClientSuspendHistory, ClientServiceHistory, ClientChild},
        props: {
            clientId: String
        },
        watch: {
            '$route' () {
                this.$router.go(0);
            }
        },
        created() {
            if (this.isNew) {
                this.currentClient = this.defaultClient
                this.editMode = true
            } else {
                this.$store.dispatch('retrieveClient', this.clientId).then((data) => {
                    this.setClient(data)
                })
            }
            this.$store.dispatch('retrieveCompanyDictList')
            this.$store.dispatch('retrieveLicenseTypeDictList')
            this.$store.dispatch('retrieveSoftwareVersionTypeDictList')
            this.$store.dispatch('retrieveClientDictionaryList')
        },
        computed: {
            isNew() {
                return this.clientId === '00000000-0000-0000-0000-000000000000'
            },
            canEditCard(){
                return this.$store.getters.hasRole(['Administrator', 'ClientManager'])
            },
            formTitle() {
                return this.$store.getters.currentClient ? this.$store.getters.currentClient.number : ''
            },
            companyDictList() {
                return this.$store.getters.companyDictList
            },
            clientDictList() {
                return this.$store.getters.clientDictionaryList
            },
            licenseTypeDictList() {
                return this.$store.getters.licenseTypeDictList
            },
            softwareVersionTypeDictList() {
                return this.$store.getters.softwareVersionTypeDictList
            },
            companyName(){
                return this.currentClient.company ? this.currentClient.company.name : null
            },
            parentClientName(){
                return this.currentClient.parentClient ? this.currentClient.parentClient.name : null
            },
            licenseTypeName() {
                return this.currentClient.licenseType ? this.currentClient.licenseType.name : null
            },
            softwareVersionTypeName() {
                return this.currentClient.softwareVersionType ? this.currentClient.softwareVersionType.name : null
            },
        },
        data() {
            return {
                currentClient: null,
                search: null,
                dialogDelete: false,
                defaultClient: {
                    id: null,
                    company: null,
                    parentCompany: null,
                    name: null,
                    address: null,
                    launchDate: null,
                    closeDate: null,
                    licenseType: {
                        id: null,
                    },
                    licenseDescription: null,
                    serverAddress: null,
                    softwareVersionType: {
                        id: null,
                    },
                    serverPassword: null,
                    networkDescription: null,
                },
                valid: !this.formError,
                vue: this,
                editMode: false,
                launchDateMenu: false,
                closeDateMenu: false,
                hostingDateMenu: false,
                clientComboboxKey: 0,
                clientComboboxKey1: 0,
                clientServiceListDialog: false,
            }
        },
        methods: {
            save() {
                if (this.$refs.form.validate()) {
                    if (!this.currentClient.id) {
                        this.currentClient.id = this.$uuid.v4()
                        this.$store.dispatch('createClient', this.currentClient).then(() => {
                            this.$router.push({path: `/pages/client/card/${this.currentClient.id}`})
                            this.editMode = false
                            this.$store.dispatch('retrieveClient', this.currentClient.id).then((data) => this.setClient(data))
                        }).catch(() => {
                            this.currentClient.id = null
                        })
                    } else {
                        this.$store.dispatch('storeClient', this.currentClient).then(() => {
                            this.$store.dispatch('retrieveClient', this.currentClient.id).then((data) => {
                                this.setClient(data)
                                this.editMode = false
                            })
                        })
                    }
                }
            },
            edit(){
                if(!this.currentClient.licenseType){
                    this.currentClient.licenseType = {
                        id: null,
                    }
                }
                if(!this.currentClient.softwareVersionType){
                    this.currentClient.softwareVersionType = {
                        id: null,
                    }
                }

                this.editMode = true
            },
            cancel(){
                if(this.isNew) {
                    this.$router.push({name: `Clients`})
                } else {
                    this.$store.dispatch('retrieveClient', this.currentClient.id).then((data) => this.setClient(data))
                    this.editMode = false
                }
            },
            getPrintersData(){
                this.$store.dispatch('retrieveClientStationsDictList')
            },
            filter (item, queryText, itemText) {
                if (item.header) return false

                const hasValue = val => val != null ? val : ''

                const text = hasValue(itemText)
                const query = hasValue(queryText)

                return text.toString()
                    .toLowerCase()
                    .indexOf(query.toString().toLowerCase()) > -1
            },
            createNewCompany(companyName){
                let entityIndex = this.companyDictList.findIndex(function (item) {
                    return item.name === companyName
                })
                if (entityIndex > -1) {
                    return
                }

                this.$store.dispatch('setCompanyDictionary', {
                    id: this.$uuid.v4(),
                    name: companyName,
                    isUpdate: false
                })
                .then((response) => {
                    this.currentClient.company = response
                    this.search = response.name
                    this.clientComboboxKey += 1
                })
            },
            setClient(client){
                this.currentClient = Object.assign({}, client)

                if(this.currentClient.launchDate) {
                    this.currentClient.launchDate = this.moment(this.currentClient.launchDate).format('YYYY-MM-DD')
                }
                if(this.currentClient.closeDate) {
                    this.currentClient.closeDate = this.moment(this.currentClient.closeDate).format('YYYY-MM-DD')
                }
                if(this.currentClient.hostingDate) {
                    this.currentClient.hostingDate = this.moment(this.currentClient.hostingDate).format('YYYY-MM-DD')
                }
                // if(!this.currentClient.company){
                //     this.currentClient.company = {
                //         id: null,
                //         name: null
                //     }
                // }
                if(!this.currentClient.licenseType){
                    this.currentClient.licenseType = {
                        id: null,
                        name: null
                    }
                }
                if(!this.currentClient.softwareVersionType){
                    this.currentClient.softwareVersionType = {
                        id: null,
                        name: null
                    }
                }

                // this.$store.dispatch('retrieveChat', {chatId: this.currentClient.activities[0].id, commentLimit: 20})
            },
            deleteItem() {
                this.dialogDelete = true
            },
            deleteItemConfirm() {
                this.$store.dispatch('deleteClient', this.currentClient.id).then(() =>
                    this.$router.push({name: 'Clients'})
                )
            },
            closeDelete() {
                this.dialogDelete = false
            },
            showClientServiceList(){
                this.clientServiceListDialog = true
            },
        }
    }
</script>

<style scoped>

</style>